<template>
  <div>
    <v-responsive :aspect-ratio="16 / 9">
      <v-card class="bg">
        <v-card-text>
          <v-row>
            <v-col cols="4">
              <h2>
                Welcome to Fife Ethylene Plant (FEP)
              </h2>
              <p>
                Before taking the site safety induction please click on the
                Covid-19 statement button below and familiarise yourself with
                our security measures.
              </p>
              <v-btn
                color="secondary"
                @click="covidStatement = !covidStatement"
              >
                <v-icon small color="red">mdi-virus</v-icon>
                COVID-19 Statement
              </v-btn>
              <br />
              <br />
              <v-btn color="secondary" @click="navToInductions()"
                >Take Induction</v-btn
              >
            </v-col>
            <v-col cols="8">
              <v-card color="rgb(144,164,174,0.9)" v-if="covidStatement">
                <v-card-title>FEP COVID-19 Security Measures</v-card-title>
                <v-card-text>
                  <p>
                    Welcome to FEP, a Covid secure site. To help prevent
                    workplace transmission of the virus, you are required to
                    follow the guidance set out in our Covid Manual, Local and
                    National Guidance. Please understand and embrace the
                    guidance to help protect yourself and others.
                  </p>
                  <p>
                    The Covid manual outlines the COVID-19 measures adopted on
                    the site for your safety.
                  </p>
                  <ul>
                    <li>
                      Do not come to site if you have had symptoms of COVID-19
                      or tested positive for COVID-19, or if you have been in
                      contact with anyone, (or suspected of having) COVID-19.
                    </li>
                    <li>
                      At FEP you must observe social distancing , if this is not
                      possible further control measures must be introduced.
                    </li>
                    <li>
                      At FEP you must wear a face covering in communal areas or
                      where your work activity requires you to.
                    </li>
                  </ul>
                  <br />
                  <p>
                    You must not begin work at FEP without understanding and
                    complying with our Covid Manual. Please raise questions and
                    feedback through your supervisor if you have any concerns or
                    can not adhere to our Covid Security measures.
                  </p>
                  <p>
                    Thank you for your full cooperation in helping to keep our
                    site a safe and healthy environment for all occupants.
                  </p>
                  <v-img src="../assets/logo.png" height="100" contain></v-img>
                </v-card-text>
                <v-card-actions> </v-card-actions>
              </v-card>
            </v-col>
          </v-row>
        </v-card-text>
        <!-- <v-btn
          fab
          class="locGfab"
          small
          absolute
          color="primary darken-2"
          @click="setLoc('General')"
          ><v-icon small>mdi-arrow-right</v-icon>
        </v-btn>
        <v-btn
          class="locG"
          color="rgb(18,18,18,0.5)"
          @click="setLoc('General')"
        >
          General Inductions
        </v-btn> -->
      </v-card></v-responsive
    >
  </div>
</template>

<script>
// import UserTestService from "@/services/UserTestService.js";

export default {
  data() {
    return {
      absolute: true,
      covidStatement: false,
      instructions: true
    };
  },
  async created() {},
  // computed: {
  //   userAccepted() {
  //     return !this.$store.state.user.privacyStatementAccepted;
  //   }
  // },
  methods: {
    navToInductions() {
      this.$router.push({
        name: "SelectTest"
      });
    }
    // async viewPdf() {
    //   try {
    //     const file = await UserTestService.getPrivacyStatement();
    //     const url = window.URL.createObjectURL(
    //       new Blob([file], { type: file.type })
    //     );
    //     window.open(url);
    //   } catch {
    //     this.$snackbarError("Failed to get privacy statement");
    //   }
    // },
    // async accept() {
    //   try {
    //     this.$store.dispatch("userAccept");
    //   } catch {
    //     this.$snackbarError("Failed to accept privacy statement");
    //   }
    // }
  }
};
</script>

<style scoped>
.bg {
  width: 100%;
  height: 100%;
  position: relative;
  background-image: url("../assets/LandingPage_01.jpg");
  background-size: contain;
}
p {
  color: black;
}
li {
  color: black;
}
.instructions {
  margin: 10px;
}
</style>
